import { createTheme } from '@mui/material';
import { customColors } from '@/app/stylesguides';

// ❗ localFont 제거 — layout.tsx에서만 선언해야 한다

const { blue, orange, gray, warning, error } = customColors;

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: blue[500]
    },
    secondary: {
      main: orange[500]
    },
    success: {
      main: blue[500]
    },
    text: {
      main: gray[900],
      secondary: gray[500],
      disabled: gray[400],
      primary: gray[700]
    },
    error: {
      main: error.dark
    },
    info: {
      main: gray[600]
    },
    ...customColors
  },

  typography: {
    fontFamily: "var(--font-pretendard), -apple-system, system-ui, Roboto, 'Noto Sans KR', 'Malgun Gothic', sans-serif",
    h0: { fontSize: '52px', lineHeight: '72px', fontWeight: 600 },
    h1: { fontSize: '40px', lineHeight: '56px', fontWeight: 600 },
    h2: { fontSize: '32px', lineHeight: '48px', fontWeight: 600 },
    h3: { fontSize: '24px', lineHeight: '38px', fontWeight: 600 },
    h4: { fontSize: '22px', lineHeight: '34px', fontWeight: 600 },
    subtitle1: { fontSize: '18px', lineHeight: '26px', wordWrap: 'break-word' },
    subtitle2: { fontSize: '16px', lineHeight: '24px', wordWrap: 'break-word' },
    body1: { fontSize: '14px', lineHeight: '22px', wordWrap: 'break-word' },
    body2: { fontSize: '12px', lineHeight: '20px', wordWrap: 'break-word' },
    caption: {
      fontSize: '12px',
      lineHeight: '20px',
      wordWrap: 'break-word'
    }
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: {}
    },

    MuiAppBar: {
      styleOverrides: {
        root: {
          justifyContent: 'center',
          backgroundColor: '#ffffff',
          boxShadow: 'none'
        },
        colorPrimary: {
          color: blue[500]
        }
      }
    },

    MuiInput: {
      styleOverrides: {
        colorPrimary: { color: gray[200] },
        colorSuccess: { color: blue[500] },
        colorSecondary: { color: '#344054' },
        colorError: { color: error.dark }
      }
    },

    MuiTypography: {
      styleOverrides: {
        colorPrimary: { color: '#101828' },
        colorSuccess: { color: '#17b26a' },
        colorSecondary: { color: '#344054' }
      }
    }
  },

  breakpoints: {
    values: {
      sm: 768,
      md: 960,
      lg: 1280
    }
  },

  cssVariables: true
});

export default theme;
